import React from 'react';
import classnames from 'classnames';
import moment from 'moment';
import _ from "lodash";

import downArrow from '../../../assets/images/down_arrow.svg';
import downArrowBlue from '../../../assets/images/down_arrow_blue.svg'
import Loading from '../../common/Loading';
import AddBlockModal from './AddBlock';
import DeleteModal from './DeleteModal';
import utils from '../../../lib/utils';

import { Prompt } from 'react-router-dom';

import sample_data from './sample.json';
import editIcon from '../../../assets/images/edit.svg';
import deleteIcon from '../../../assets/images/delete.svg';

import './index.scss';

const sortDataBy =(data, byKey, order)=>{
    let sortedData;
    if(byKey == 'dates'){
        sortedData = data.sort(function(a,b){
          let x = a.dates.length>0 ? moment(a.dates[0]): moment().subtract(1, 'y');
          let y = b.dates.length>0 ? moment(b.dates[0]): moment().subtract(1, 'y');
          if(x.isSameOrAfter(y)){return 1*order;}
          if(x.isSameOrBefore(y)){return -1*order;}
          return 0;
        });
      }else if(byKey == 'start_time'){
        sortedData = data.sort(function(a,b){
          let x = moment(a.start_time,'HH:mm:ss');
          let y = moment(b.start_time,'HH:mm:ss');
          if(x.isAfter(y)){return 1*order;}
          if(x.isBefore(y)){return -1*order;}
          return 0;
        });
      }else if(byKey == 'resource_ids'){
          sortedData = data.sort(function(a,b){
            let x = a.resource_ids.length;
            let y = b.resource_ids.length;
            if(x>y){return 1*order;}
            if(x<y){return -1*order;}
            return 0;
          });
      } else if(byKey == 'staff_ids'){
          sortedData = data.sort(function(a,b){
            let x = a.staff_ids.length;
            let y = b.staff_ids.length;
            if(x>y){return 1*order;}
            if(x<y){return -1*order;}
            return 0;
          });
      }else if(byKey == 'service_ids'){
          sortedData = data.sort(function(a,b){
            let x = a.service_ids.length;
            let y = b.service_ids.length;
            if(x>y){return 1*order;}
            if(x<y){return -1*order;}
            return 0;
          });
      }else{
        sortedData = data.sort((a,b)=>{
          let x = moment.duration(a.duration).format('mm');
          let y = moment.duration(b.duration).format('mm');
          console.log('XY',x,y);
          if(x>y){return 1*order;}
          if(x<y){return -1*order;}
          return 0;
          })
      }
    return sortedData;
  }
const filterService = (services) => {
   return  services? services.filter(service=>service.kind==='SESSION'):[];
}
const  camalize = (word) => {
    return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
}
export default class DentalSchedulePreview extends React.Component {
    constructor() {
        super();
        this.state = {
            addBlockModalOpen:false,
            deleteServiceModalOpen:false,
            selectedData:{},
            currentpage:1,
            totalPage:1,
            countPerPage:10,
            serviceCount:1,
            showPopup: false,
            showAddPopup: false,
            showDeletePopup: false,
            showFailurePopup:false,
            sortField: 'dates',
            sortOrder:1,
            name:'',
            selectedDuration: 'PT5M',
            selectedProcedureCodes:[],
            editSchedule:false,
        };
      } 

    componentDidMount(){
        const { auth, business } = this.props;
        const {  studio_id } = auth;
        const { countPerPage } = this.state;
        const bzid = this.props.business.id || studio_id;  
        if(bzid){
            this.props.getBusinessDetails(bzid);
        }
        if(business?.businessDetailsFetched && !utils.isEmptyObject(business?.details)){
            this.props.storeService(business.details?.services);
            const data = {
                location_id: business?.details?.locations[0]?.id,
                business_id: business.id
            }
            this.props.getBlockRules(data);
            const serviceLength = filterService(business?.details?.services).length;
            this.setState({
                serviceCount: serviceLength,
                totalPage: Math.ceil(serviceLength/countPerPage)
            })
        }
    } 

    componentWillReceiveProps(nextProps){
        const { auth, business, schedules } = nextProps;
        const {  studio_id } = auth;
        const { countPerPage, currentpage } = this.state;
        const bzid = this.props.business.id || studio_id;  
        const serviceCount = this.getBlockRulesAsArray(schedules).length;
        const currentServiceCount = this.getServices().length;
        if(!utils.isEmptyObject(nextProps?.business?.details) && nextProps?.business?.details!== this.props?.business?.details){
            this.props.storeService(business.details?.services);
            const data = {
                location_id: business?.details?.locations[0]?.id,
                business_id: business.id
            }
            this.props.getBlockRules(data);
            this.setState({
                serviceCount: serviceCount,
                totalPage: Math.ceil(serviceCount/countPerPage)
            })
        }
        if(schedules.addScheduleBlocks!==this.props.schedules.addScheduleBlocks && schedules.addScheduleBlocksSuccess){
            this.setState({
                addBlockModalOpen:false,
                serviceCount: currentServiceCount,
                totalPage: Math.ceil(currentServiceCount/countPerPage),
                name:'',
                selectedDuration: 'PT5M',
                selectedProcedureCodes:[],
            })
            this.addPopup();
        }
        if(schedules.addScheduleBlocks!==this.props.schedules.addScheduleBlocks && schedules.addScheduleBlocksfail){
            this.setState({
                addBlockModalOpen:false,
                serviceCount: currentServiceCount,
                totalPage: Math.ceil(currentServiceCount/countPerPage),
                name:'',
                selectedDuration: 'PT5M',
                selectedProcedureCodes:[],
            })
            this.failedPopup();
        }
        if(schedules.editServiceType!==this.props.schedules.editServiceType && schedules.editServiceSuccess){
            this.setState({
                addBlockModalOpen:false,
                name:'',
                selectedDuration: 'PT5M',
                selectedProcedureCodes:[],
            })
            this.upDatePopup();
        }
        if(schedules.deleteScheduleBlocks!==this.props.schedules.deleteScheduleBlocks && schedules.deleteScheduleBlocks === false){
        
            this.closeDeleteModal();
            if(schedules.deleteScheduleBlocksSuccess){
            this.deletePopup();
            this.setState({
                serviceCount: currentServiceCount,
                totalPage: Math.ceil(currentServiceCount/countPerPage),
                currentpage: currentpage> Math.ceil(currentServiceCount/countPerPage) ? currentpage-1: currentpage
            })
            }else{
                this.failedPopup();
            }
        }
    }
    failedPopup = () => {
        this.setState({
          showFailurePopup: true
        })
        setTimeout(() => {
          this.setState({
            showFailurePopup: false
          })
        }, 3000);
    }

    addPopup = () => {
        this.setState({
          showAddPopup: true
        })
        setTimeout(() => {
          this.setState({
            showAddPopup: false
          })
        }, 3000);
    }

    upDatePopup = () => {
        this.setState({
          showPopup: true
        })
        setTimeout(() => {
          this.setState({
            showPopup: false
          })
        }, 3000);
    }

    deletePopup = () => {
        this.setState({
          showDeletePopup: true
        })
        setTimeout(() => {
          this.setState({
            showDeletePopup: false
          })
        }, 3000);
    }
    openServiceModal=()=>{
        this.setState({
            addBlockModalOpen:true
        })
    }
    editService=(service)=>{
        this.setState({
            addBlockModalOpen:true,
            editSchedule:true,
            selectedData:service
        })
    }

    closeServiceModal=()=>{
        this.setState({
            editSchedule:false,
            addBlockModalOpen:false,
            selectedData:{}
        })
        this.props.clearServiceFlags();
    }

    closeDeleteModal=()=>{
        this.setState({
            deleteServiceModalOpen:false,
            selectedData:{}
        })
    }

    deleteService=(service)=>{
        console.log('deleteService',service)
        this.setState({
            deleteServiceModalOpen:true,
            selectedData:service
        })
    }

    deleteServiceType=(service)=>{
        const { business } = this.props;
        const data = {
            business_id: business.id,
            "status": false
        }
        console.log("DELETE",data,service);
        this.props.deleteBlockRules({'body':data, 'rule_id':service.id});
    }
    getProcedureCode=(proc_id)=>{
        const { schedules } = this.props;
        const procedures = schedules.procedure_codes.filter(procedure=>procedure.id==proc_id)
        return procedures.length>0? procedures[0].code: proc_id;
    }
    getPages=()=>{
        const {  totalPage } = this.state;
        let pages = [];
        for(let i=0;i<totalPage;i++){
            pages.push(i+1);
        }
        return pages;
    }
    changePage=(page)=>{
        this.setState({
            currentpage:page
        })
    }
    nextPage=()=>{
        const { currentpage, totalPage} = this.state;
        if(currentpage<totalPage){
            this.setState({
                currentpage: currentpage+1
            })
        }
    }
    prevPage=()=>{
        const { currentpage} = this.state;
        if(currentpage>1){
            this.setState({
                currentpage: currentpage-1
            })
        }
    }
    getServices=()=>{
        const { currentpage, countPerPage, sortField, sortOrder} = this.state;
        const { schedules } = this.props;
        const keys = Object.keys(schedules?.scheduleBlocks);
        const blockRules = keys.map(key=>({...schedules?.scheduleBlocks[key], 'id': key}));
        let blocks = blockRules?.length>0? sortDataBy(blockRules, sortField, sortOrder): [];
        const start = ((currentpage-1)*countPerPage);
        const end = currentpage*countPerPage> blocks.length ? blocks.length:currentpage*countPerPage;
        console.log('blocks',blockRules);
        return blocks.slice(start, end);
    }
    sortType=(field, order)=>{
        this.setState({
            sortField: field,
            sortOrder: order
        })
    }
    handleChangeInForm=(event)=>{
        this.setState({
          [event.target.name]:event.target.value
        })
    }
    getBlockRulesAsArray = (schedules) =>{
        return Object.values(schedules?.scheduleBlocks) || [];
    }
    getServiceName=(service_ids)=>{
        const { business } = this.props;
        const display_services = service_ids.slice(0,4);
        let servicenames = display_services?.map(serviceId=>business?.serviceById[serviceId]?.name).join(', ');
        console.log('servicenames',servicenames)
        servicenames+=service_ids.length>4? '\xa0+'+(service_ids.length-4)+'\xa0more' :'';
        console.log('servicenames',service_ids.length>4, service_ids.length-4,servicenames);
        return servicenames;
    }
    getOperatoryName=(operatory, staffs, services)=>{
        const { business } = this.props;
        const resource = business?.details?.resources.filter(resource=>operatory.includes(resource.id));
        const allResource =  _.isEqual(resource,  business?.details?.resources);
        if(staffs.length<1 && services.length<1){
            return resource.length>0?resource.map(obj => obj.name).join(', '):'';
        }else if(services.length<1 && (resource.length<1 || allResource) && staffs.length>0){
            return '';
        }else if(staffs.length<1 && (resource.length<1 || allResource) && services.length>0){
            return '';
        }
        return resource.length>0?resource.map(obj => obj.name).join(', '):'';
    }
    getProviderName=(provider)=>{
        const { business } = this.props;
        const resource = business?.staffById[provider];
        return resource?.name || '';
    }

    render(){
        const { softwares, business, schedules, auth } = this.props;
        const { service_dropdwon, addBlockModalOpen, deleteServiceModalOpen, currentpage, countPerPage, totalPage, showPopup, sortOrder, sortField, showDeletePopup, selectedData, editSchedule, showAddPopup, showFailurePopup} = this.state;
        const {  studio_id } = auth;
        const bzid = business.id || studio_id;  
        const blockRulesLength = this.getBlockRulesAsArray(schedules).length;
        const pmsList = business?.details?.locations?.length>0? business.details?.locations[0].location_metadata?.associated_pms:null;
        console.log('blockRulesLength',blockRulesLength);
        return(
            <div className="scheduleblock">
            <Prompt
                when={
                    schedules.updateBusinessData
                }
                message={ 
                    'There are unsaved changes, are you sure you want to leave without saving?'
                }
            />

        {(softwares.studioId !== "" || bzid !== '') ?
           (<>
            <div className='scheduleblock_title'>
                    <div className="scheduleblock_title_content">
                        <div className="title">Scheduling Blocks</div>
                        <button className="add-service" onClick={this.openServiceModal}>Block time</button>
                    </div>
                    <div className='scheduleblock_title_pms'><div>{pmsList}</div> <div className='scheduleblock_title_pms_synctime'>Last updated: {moment(business?.details?.last_sync_time).fromNow()}</div></div>
            
            {(business.getBusinessDetails || schedules.getScheduleBlocks)?(<div className="scheduleblock_title_table"><div className="scheduleblock_loader">
            <Loading />
            </div></div>):(
                    <div className="scheduleblock_title_table">
                        <div className="scheduleblock_title_table_header">
                            <div className="row date">Date/Day of the week<img className={classnames('arrow',{'rotate-arrow':(sortOrder=== -1 && sortField==='dates')})}  src={sortField!=='dates'?downArrow:downArrowBlue} onClick={()=>this.sortType('dates',sortOrder*-1)}/> </div>
                            <div className="row time">time <img className={classnames('arrow',{'rotate-arrow':(sortOrder=== -1 && sortField==='start_time')})} src={sortField!=='start_time'?downArrow:downArrowBlue} onClick={()=>this.sortType('start_time',sortOrder*-1)} /> </div>
                            <div className="row service">Service <img className={classnames('arrow',{'rotate-arrow':(sortOrder=== -1 && sortField==='service_ids')})} src={sortField!=='service_ids'?downArrow:downArrowBlue} onClick={()=>this.sortType('service_ids',sortOrder*-1)} /> </div>
                            <div className="row provider">Provider <img className={classnames('arrow',{'rotate-arrow':(sortOrder=== -1 && sortField==='staff_ids')})} src={sortField!=='staff_ids'?downArrow:downArrowBlue} onClick={()=>this.sortType('staff_ids',sortOrder*-1)} /> </div>
                            <div className="row operatory">Operatory <img className={classnames('arrow',{'rotate-arrow':(sortOrder=== -1 && sortField==='resource_ids')})} src={sortField!=='resource_ids'?downArrow:downArrowBlue} onClick={()=>this.sortType('resource_ids',sortOrder*-1)} /> </div>
                            <div className="row empty"></div>
                        </div>
                        {blockRulesLength<1?
                        (<div className="scheduleblock_title_table_body">
                           <div className="no-service-types">No blocked times. If you’d like to define a time frame when TrueLark cannot book appointments block time above.</div>
                        </div>):
                        (<div className="scheduleblock_title_table_body">
                        {this.getServices().map(data=>{
                            return <div className="servie-block-container">
                                <div className="servie-block-container_date">
                                    <div>{data?.dates?.map((date,index)=><span>{date?moment(date,'YYYY-MM-DD').format('MMM DD, YYYY'):''} {index<data.dates.length-1?',\xa0':''}</span>)}</div>
                                    <div>{data?.day_of_week?.map((day,index)=><div>{camalize(day)}{index<data.day_of_week.length-1?',\xa0':''}</div>)}</div>
                                    
                                </div>
                                
                                <div className="servie-block-container_time">{moment(data.start_time,'HH:mm:ss').format('h:mm A')}-{moment(data.end_time,'HH:mm:ss').format('h:mm A')}</div>
                                <div className={classnames("servie-block-container_service",{'empty-list':(data.service_ids.length<1)})}>{data.service_ids.length>0 ? this.getServiceName(data.service_ids):'-'}</div>
                                <div className={classnames("servie-block-container_provider",{'empty-list':(data.staff_ids.length<1)})}>{data?.staff_ids.length>0? data?.staff_ids?.map((staff,index)=><sapn>{this.getProviderName(staff)}{index<data.staff_ids.length-1?',\xa0':''}</sapn>):'-'}</div>
                                <div className={classnames("servie-block-container_operatory",{'empty-list':(data.resource_ids.length<1)})}>{data?.resource_ids.length>0 ? this.getOperatoryName(data.resource_ids, data?.staff_ids, data.service_ids):'-'}</div>
                    
                                <div className="servie-block-container_actions"><div className="servie-block-container_actions_wrapper"><img src={editIcon} onClick={()=>this.editService(data)}/> <img src={deleteIcon} onClick={()=>this.deleteService(data)}/> </div></div>
                            </div>
                        })}
                        </div>)}
                        {blockRulesLength>0 &&
                        <>
                        {totalPage>1 &&
                        <div className="scheduleblock_title_table_pagination">
                            <div className="count">Showing {((currentpage-1)*countPerPage)+1}-{currentpage*countPerPage>blockRulesLength ? blockRulesLength:currentpage*countPerPage} of {blockRulesLength} entries</div>
                            <div className="paging">
                                {currentpage!== 1 && <span className={classnames('page-number')} onClick={()=>this.prevPage()}>PREV</span>}
                                {this.getPages().map(page=><span className={classnames('page-number',{'active':page===currentpage})} onClick={()=>this.changePage(page)}>{page}</span>)}
                                {totalPage!==currentpage && <span className={classnames('page-number')} onClick={()=>this.nextPage()}>NEXT</span>}
                            </div>
                        </div>}
                        <div className="scheduleblock_title_table_save"><button className="btn btn--primary btn--lg" onClick={()=>this.props.syncServiceTypes(bzid)} disabled={schedules.syncBusiness}>{schedules.syncBusiness?'SAVING..':'SAVE'}</button></div>
                        </>}
                    </div>)}
            </div>
            </>):
            (<div className="non-authenticated">
            Complete practice management software authorization under <a className="setup-link" href="/#/app/setup/summary">AI Setup &gt; Setup</a>, to start defining your schedule.
            </div>)}
            {showAddPopup &&<div className="copy-webhook">
                      <span className="tick-mark"><i className="material-icons">check</i></span>
                      Block was added successful. Please save the changes for it to reflect.
            </div>}
            {showPopup &&<div className="copy-webhook">
                      <span className="tick-mark"><i className="material-icons">check</i></span>
                      Update was successful. Please save the changes for it to reflect.
            </div>}
            {showDeletePopup && <div className="copy-webhook">
                      <span className="tick-mark"><i className="material-icons">check</i></span>
                      Delete was successful. Please save the changes for it to reflect.
            </div>}
            {showFailurePopup && <div className="copy-webhook-failure">
                      <span className="tick-mark"><i className="material-icons">check</i></span>
                    Something went wrong
            </div>}
            {addBlockModalOpen && <AddBlockModal  business={business} modelopen={addBlockModalOpen} selectedData={selectedData} addBlockRules={this.props.addBlockRules} editScheduleAPI={this.props.editScheduleAPI} bzid={bzid} closeServiceModal={this.closeServiceModal} editSchedule={editSchedule}  editScheduleData={selectedData} {...this.props}
            />}
            {deleteServiceModalOpen && <DeleteModal  selectedData={selectedData} modelopen={deleteServiceModalOpen} closeServiceModal={this.closeDeleteModal} deleteServiceType={this.deleteServiceType} schedules={schedules} business={business}/>}
            </div>
          )
      }

}